/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @interface ViewActionSet
 */

/**
 * Check if a given object implements the ViewActionSet interface.
 */
export function instanceOfViewActionSet(value) {
  return true;
}
export function ViewActionSetFromJSON(json) {
  return ViewActionSetFromJSONTyped(json, false);
}
export function ViewActionSetFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
export function ViewActionSetToJSON(value) {
  return value;
}